// extracted by mini-css-extract-plugin
export default {"box":"footer_box__+zxlI","switchButton":"footer_switchButton__hZHMS","navLinks":"footer_navLinks__0Fw7J","privacySenctence":"footer_privacySenctence__aa-eT"};